import React from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';

import { exitTrack } from '@/utils/tracking/utils/exitTrack';
import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE, isIosReg, SourceInUrl } from '@/utils/constants';
import { dispatchTrack, chatbotTrackObj } from '@/utils/tracking';
import { getChildInject, bridgeCallFunc } from '@/utils/instantLoaded/tools';
import {
  Navbar,
  SessionArea,
  BottomFixedArea,
} from '@/components/loadFirstScreen';
import { getQueryForm } from '@/utils/instantLoaded/toolsWithoutDeps';
// 为了引入pullToLoad样式使sessionArea外层有paddingTop
import '@/components/PullToLoad/style.scss';
import reporter from '@/utils/report';

@inject(getChildInject('firstInit'))
@observer
export default class First extends React.PureComponent {
  @observable shortcutList = [];

  constructor(props) {
    super(props);
    this.trackingname = TRACKING_TYPE.BACK;
    const { userAgent } = window.navigator;
    this.isIos = isIosReg.test(userAgent);
  }

  @action
  async updateState(key, value) {
    this[key] = value;
  }

  componentDidMount() {
    // 弹窗初次弹出数
    reporter.apiBatchReport({ type: 'count', value: { label: 'channel_chat_pv' }});
    // 监听系统原生返回
    this.handleNativeTapBack();

    const { firstInit, firstInit: { initStore: { searchUrl }}} = this.props;
    const source = getQueryForm('__source__', searchUrl);
    const isFromPN = source === SourceInUrl.PUSH_NOTIFICATION;

    // 埋点用 - view of page
    dispatchTrack({ operation: TRACKING_OPERATION.VIEW, data: { from_pn: isFromPN }});

    firstInit.INIT_CHATBOT();
  }

  // 退出会话时的确认弹窗
  tapBackConfirmModalInstance = null;

  handleNativeTapBack() {
    bridgeCallFunc(() => {
      window.bridgeRegisterHandler('didTapBack', () => {
        this.handleTapBack();
      });
    });
  }

  handleTapBack = () => {
    const { firstInit } = this.props;
    const { initStore: { isMainRendered }} = firstInit;

    // 切换到main组件后不需要再响应
    if (isMainRendered) {
      return;
    }

    // 点击埋点
    this.trackingHandler();
    exitTrack();
    chatbotTrackObj.flush();

    // 推出当前页面
    window.bridgeCallHandler('popWebView', {}, function () { });
  };

  // 埋点用 - 点击事件
  trackingHandler = () => {
    dispatchTrack({
      operation: TRACKING_OPERATION.CLICK,
      section: TRACKING_SECTION[this.trackingname],
      target: TRACKING_TARGET[this.trackingname],
    });
  };

  render() {
    return (
      <>
        <Navbar />
        <div id="global-scroll" className="pull-to-load global-scroll">
          <SessionArea />
        </div>
        <BottomFixedArea />
      </>
    );
  }
}
